<template>
  <div class="form-wrapper" >
    <div class="form-wrapper-body m-0">
      <div class="ActivityAftercareSetUpChildModalBody">
        <div class="customForm--container">
          <keep-alive>
            <component 
              :key="customComponentRenderTrigger"
              :is="customForm"
              :customForm="options.customForms[customComponentRenderTrigger]"
              @errorInAnswer="disableButton = $event"
            />
          </keep-alive>
        </div>
      </div>
    </div>
    <div class="form-wrapper-footer d-flex justify-content-between">
      <div>
        <button
          :class="[
            'form-wrapper-footer-button',
            'primary-btn',
          ]"
          :style="{ width: '150px' }"
          @click="moveBack"
        >
          Go Back
        </button>
      </div>
      <div>
        <button :key="customComponentRenderTrigger"
                :class="['form-wrapper-footer-button', 'primary-btn', options.activityStatus === 'Full' && 'form-wrapper-footer-button-waitlist', isLoading && 'ie-spinner']"
                :style="{'width':'150px'}"
                :disabled="disableButton.includes(true)"
                @click.stop="moveForward"
                v-spinner="isLoading"
        >
            <template v-if="!finish">Continue</template>
            <template v-else-if="options.activityStatus === 'Online'">{{ isNewPaymentFlow ? 'Pay Now' : 'Add to Cart' }}</template>
            <template v-else-if="options.activityStatus === 'Full'"> Add to Waitlist </template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import { FormMixin } from "@/mixins/FormMixin";
import { GetUserInfoFromLocalStorage } from "@/mixins/GetUserInfoFromLocalStorage";
import { NotificationsTypes } from '@/constants/notificationsTypes';
import { eventBus } from '@/main';

const CustomForm = () => import('@/components/modals/CustomForm/CustomForm.vue');
const ActivityAftercareSetUpChildModal = () => import(/* webpackChunkName: "activities" */ '@/components/modals/ActivityAftercareSetUpChildModal');
const ActivityClassSetUpChildModal = () => import(/* webpackChunkName: "activities" */ '@/components/modals/ActivityClassSetUpChildModal');
const ActivityCampSetUpChildModal = () => import(/* webpackChunkName: "activities" */ '@/components/modals/ActivityCampSetUpChildModal');
const ActivityAftercareDropInModal = () => import(/* webpackChunkName: "activities" */ '@/components/modals/ActivityAftercareDropInModal');

export default {
  name: "CustomFormModal",

  data() {
    return {
      customComponentRenderTrigger: 0,
      checkFieldsRequiredItem: [],
      customForm: CustomForm,
      disableButton: [],
      modalOption: [ActivityAftercareSetUpChildModal, ActivityClassSetUpChildModal, ActivityCampSetUpChildModal, ActivityAftercareDropInModal]
    }
  },

  computed: {
    ...mapGetters([
      "options",
      "isLoading",
      "customForms",
      "schoolInfo"
    ]),

    isNewPaymentFlow() {
      return this.schoolInfo && this.schoolInfo.schoolFeatures && this.schoolInfo.schoolFeatures['new-payments'];
    },

    finish() {
      return this.options.customForms.length == (this.customComponentRenderTrigger + 1);
    }
  },

  mixins: [GetUserInfoFromLocalStorage, FormMixin],

  methods: {
    ...mapActions([
      "showSpinner",
      "closeModal",
      'openModal',
      'createNotification'
    ]),

    submitEnroll() {
      eventBus.$emit('submitCustomForms');
    },

    checkFieldsRequired() {
      this.checkFieldsRequiredItem = [];
      let check = false;
      this.options.customForms[this.customComponentRenderTrigger].formFields.forEach(element => {
        if (element.required) {
          const answerForm = this.customForms.find(item => item.formId === element.formId);
          const res = answerForm.answers.find(item => item.formFieldId === element.id);
          if(!res.answer) {
            check = true;
            this.checkFieldsRequiredItem.push(false);
          }
        }
      })
      if (check) {
        this.createNotification({
          message: 'Please fill in all required fields!',
          type: NotificationsTypes.WARNING
        });
        check = false
      }
    },

    moveForward() {
      this.checkFieldsRequired();
      if(!this.checkFieldsRequiredItem.includes(false)) {
        if ( this.customComponentRenderTrigger < (this.options.customForms.length - 1) ) {
          this.customComponentRenderTrigger += 1;
        } else {
          this.submitEnroll();
          this.disableButton.push(true);
        }
      }
    },

    moveBack() {
      if ( this.customComponentRenderTrigger !== 0 ) {
        this.customComponentRenderTrigger -= 1;
      } else {
        this.openModal({
          modal: this.modalOption[this.options.modalType],
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";

.ActivityAftercareSetUpChildModalBody {
  height: 100%;
  margin: 0 30px;

  &-title {
    margin-bottom: 12px;
    text-align: left;
    word-break: break-word;
    font-size: 28px;
    font-weight: 700;
    color: $Dark;
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      //for IE
      word-break: break-all;
    }
  }

  &-label {
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 700;
  }

  &-full {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-weight: 700;

    &-name {
      font-size: 16px;
      color: $Copyright;
      word-break: break-word;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        //for IE
        word-break: break-all;
      }
    }

    &-description {
      font-size: 14px;
      color: $SimplyAfterSchoolRed;
    }
  }

  &-checkboxes {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &-checkbox {
      position: relative;
      width: 35px;
      height: 35px;
      margin: 5px 0;
      border-radius: 2px;
      cursor: pointer;
      background-color: $ComplementaryBgTxtDarker;

      input {
        position: absolute;
        height: 0;
        width: 0;
        display: none;
        cursor: pointer;

        &:checked ~ span {
          border-radius: 2px;
          color: $White;
          background-color: $Violet;
        }
      }

      span {
        position: absolute;
        top: 0;
        left: 0;
        width: 35px;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 11px;
        font-weight: 500;
        color: $Dark;
      }
    }

    .disabled {
      opacity: 0.4;
      cursor: no-drop;
    }
  }
}

.customForm--container {
  display: flex;
  flex-direction: column;
  justify-content: center;

  & .customForm--button {
    margin: auto;
    border-radius: 24.5px;
    font-weight: 500;
    height: 49px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      cursor: pointer;
    }
  }
}

.ActivityClassSetUpChildModalBottom {
  font-size: 24px;
  font-weight: 700;
  color: $SoftBlue;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/CustomFormModal.vue